import { useDataFetch, Indicator } from '../providers/DataFetch.provider';

const useDataFetchIndicator = (): [
  [boolean, string?, Indicator?],
  (isFetching: boolean, msg?: string, indicator?: Indicator) => void,
] => {
  const { isDataFetching, loadingMessage, indicator, setDataFetchingInfo } = useDataFetch();

  return [[isDataFetching, loadingMessage, indicator], setDataFetchingInfo];
};

export default useDataFetchIndicator;
